import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import {
  defineMessages,
  FormattedMessage,
  intlShape,
  injectIntl,
} from 'react-intl';
import noop from 'lodash/noop';

import muiWithStyles from '@material-ui/core/styles/withStyles';
import withStyles from 'isomorphic-style-loader/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';

import { Interweave } from 'interweave';
import s from './ConfirmDeleteDialog.scss';

const messages = defineMessages({
  cancelRemoveLabel: {
    id: 'General.refuseDeleteBtnLabel',
    defaultMessage: 'Oops! no thanks',
  },
  deleteBtnLabel: {
    id: 'General.deleteBtnLabel',
    defaultMessage: 'Delete',
  },
});

const styles = theme => ({
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  buttonWrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fff',
    '&:hover': {
      backgroundColor: green[700],
      color: '#fff',
    },
  },
});

@injectIntl
@muiWithStyles(styles)
@withStyles(s)
export default class ConfirmDeleteDialog extends React.PureComponent {
  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    isDeleting: PropTypes.bool.isRequired,
    isDeleted: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onCloseSnackbar: PropTypes.func,
    submit: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    deletingError: PropTypes.string,
    snackbarMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    intl: intlShape.isRequired,
    deleteBtnLabel: PropTypes.node,
    cancelBtnLabel: PropTypes.node,
    deleteBtnId: PropTypes.string,
    submitColor: PropTypes.string,
    classes: PropTypes.shape({
      buttonSuccess: PropTypes.string,
      buttonProgress: PropTypes.string,
    }),
  };

  static defaultProps = {
    description: '',
    deletingError: '',
    deleteBtnLabel: null,
    cancelBtnLabel: null,
    deleteBtnId: '',
    submitColor: 'secondary',
    snackbarMessage: '',
    onCloseSnackbar: noop,
    isDeleted: false,
    classes: {},
  };

  render() {
    const {
      isShown,
      onClose,
      submit,
      isDeleting,
      title,
      description,
      classes,
      snackbarMessage,
      onCloseSnackbar,
      isDeleted,
      deletingError,
      deleteBtnLabel,
      cancelBtnLabel,
      deleteBtnId,
      submitColor,
      ...rest
    } = this.props;

    const message = deletingError || snackbarMessage;

    return (
      <div>
        <Dialog
          open={isShown}
          onClose={onClose}
          classes={{ paper: s.dialog }}
          {...rest}
        >
          <DialogTitle classes={{ root: s.dialogTitle }}>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText component="span">
              {description}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              data-test-id="kfWSir0JmAKLtvagg_EkG"
              onClick={onClose}
              color="primary"
              disabled={isDeleting}
            >
              {cancelBtnLabel || (
                <FormattedMessage {...messages.cancelRemoveLabel} />
              )}
            </Button>
            <Button
              data-test-id="nfFe30yS7BrocRIBcMy1R"
              onClick={submit}
              variant="contained"
              color={submitColor}
              autoFocus
              disabled={isDeleting}
              id={deleteBtnId}
              className={classNames({
                [classes.buttonSuccess]: isDeleted,
              })}
            >
              {isDeleting && (
                <CircularProgress
                  size={25}
                  className={classes.buttonProgress}
                />
              )}
              {deleteBtnLabel || (
                <FormattedMessage {...messages.deleteBtnLabel} />
              )}
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={(!!deletingError || isDeleted) && message}
          onClose={onCloseSnackbar}
          autoHideDuration={2000}
          message={
            typeof message === 'string' ? (
              <Interweave tagName="div" content={message} />
            ) : (
              message
            )
          }
        />
      </div>
    );
  }
}
